// import classes
import { iconButtonClasses } from "@mui/material/IconButton";
import { listItemSecondaryActionClasses } from "@mui/material/ListItemSecondaryAction";
export default {
    styleOverrides: {
        root: ({ theme }) => ({
            [`.${listItemSecondaryActionClasses.root}`]: {
                [`.${iconButtonClasses.root}`]: {
                    color: theme.vars.palette.outline.variant,
                    transition: theme.transitions.create("color"),
                },
            },
            "&:hover": {
                [`.${listItemSecondaryActionClasses.root}`]: {
                    [`.${iconButtonClasses.root}`]: {
                        color: theme.vars.palette.primary.main,
                    },
                },
            },
        }),
    },
};
